@if (sli() !== null) {
  <span [class]="valueClasses()"> {{ sli() | localePercent }} </span>
} @else {
  <span class="font-mono text-sm text-subtle">—</span>
}
